import { Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Browser } from '@capacitor/browser';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { LoaderService } from 'src/app/services/loader.service';
import { ProcessScreenComponent } from 'src/app/account/process-screen/process-screen.component';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { WalletStore } from 'src/app/stores/wallet.store';
import { MiscService } from 'src/app/services/misc.service';

@Component({
  selector: 'app-add-money',
  templateUrl: './add-money.component.html',
  styleUrls: ['./add-money.component.scss'],
})
export class AddMoneyComponent implements OnInit {
  amount_validator: FormGroup;
  validation_errors: any;
  @Input() payment_method: number = null;

  constructor(
    private modalCtrl: ModalController,
    private FormBuilder: FormBuilder,
    private loaderService: LoaderService,
    private translate: TranslateService,
    private walletStore: WalletStore
  ) {}

  ngOnInit() {
    this.getErrors();
    this.amount_validator = this.FormBuilder.group({
      amount: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  getErrors() {
    this.validation_errors = {
      amount: [
        {
          type: 'required',
          message: `FINANCE.ADD_MONEY_ERROR`,
        },
      ],
    };
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  async submit() {
    var data = {
      amount: this.amount_validator.value.amount,
      payment_method: this.payment_method,
    };
    this.loaderService.showLoading();
    try {
      var resp: any = await this.walletStore.addMoney(data);
      if (resp.data) {
        this.modalCtrl.dismiss();
        var $this = this;
        Browser.addListener('browserFinished', function closeBrowser() {
          $this.loaderService.presentToast(
            $this.translate.instant('FINANCE.PAYMENT_SUCCESS'),
            'middle',
            'success'
          );
          $this.modalCtrl.dismiss();
        });
        this.loaderService.dismissLoading();
        resp.data.dynamic_Link &&
          (await Browser.open({ url: resp.data.dynamic_Link }));
        var checkPayment = true;
        this.getUrl(checkPayment, resp.data.reference_id, resp.data);
      }
      this.loaderService.dismissLoading();
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        this.translate.instant(
          error.error.data ? error.error.data : 'FINANCE.PAYMENT_FAILED'
        ),
        'middle',
        'danger',
        3000
      );
    }
  }

  async getUrl(checkPayment: boolean, reference_id: number, response: any) {
    const modal = await this.modalCtrl.create({
      component: ProcessScreenComponent,
      backdropDismiss: false,
      componentProps: {
        checkPayment: checkPayment,
        referenceId: reference_id,
        paymentRef: response?.paypay_reference_no || null,
        paymentEntity: response?.entity_id || null,
        amount: response?.amount,
      },
    });
    modal.present();
    const resp = await modal.onDidDismiss();
    // if (!resp.data) {
    //   this.router.navigate(['/my-product-bag'], { replaceUrl: true });
    // }
  }
}
